<ion-content>
  <nav class="side-menu" aria-label="Profile menu">
    <header class="sm-hero">
      <button type="button" class="sm-close" (click)="closeMenu()" aria-label="Close menu">
        <ion-icon name="close" aria-hidden="true"></ion-icon>
      </button>

      <div class="sm-avatar">
        <app-avatar></app-avatar>
        <label class="sm-avatar-badge" for="single" aria-label="Change profile photo">
          <ion-icon name="camera" aria-hidden="true"></ion-icon>
        </label>
      </div>

      <h2 class="sm-name">{{ loggedInUser?.firstName }} {{ loggedInUser?.lastName }}</h2>
      @if (loggedInUser?.username) {
        <p class="sm-handle">{{ '@' + loggedInUser?.username }}</p>
      }
      <button type="button" class="sm-profile-link" (click)="goToMyProfile()">
        See Profile
        <ion-icon name="chevron-forward" aria-hidden="true"></ion-icon>
      </button>

      <div class="sm-stats">
        <button type="button" class="sm-stat" (click)="goToPage('my-charities')">
          <span class="sm-stat-value">{{ following }}</span>
          <span class="sm-stat-label">Following</span>
        </button>
        <button type="button" class="sm-stat" (click)="goToPage('history')">
          <span class="sm-stat-value">{{ donations }}</span>
          <span class="sm-stat-label">Donations</span>
        </button>
        <button type="button" class="sm-stat" (click)="goToPage('credits')">
          <span class="sm-stat-value">{{ credits }}</span>
          <span class="sm-stat-label">Credits</span>
        </button>
      </div>
    </header>

    @if (!authorityLoaded || hasPortals) {
      <section class="sm-switches" aria-label="Portals">
        @if (!authorityLoaded) {
          <ion-skeleton-text class="sm-switch-skeleton" animated></ion-skeleton-text>
        } @else {
          @if (permittedCharities.length > 0) {
            <button
              type="button"
              class="sm-switch"
              (click)="switchToCharity()"
              [disabled]="isSwitchingToCharity"
              [attr.aria-busy]="isSwitchingToCharity">
              <span class="sm-switch-icon" aria-hidden="true"><ion-icon name="heart"></ion-icon></span>
              <span>
                <span class="sm-switch-title">{{ isSwitchingToCharity ? 'Switching...' : 'Switch to Charity Portal' }}</span>
                <span class="sm-switch-note">{{ portalNote(permittedCharities, 'charities') }}</span>
              </span>
              @if (isSwitchingToCharity) {
                <ion-spinner name="crescent" aria-hidden="true"></ion-spinner>
              } @else {
                <ion-icon name="swap-horizontal" aria-hidden="true"></ion-icon>
              }
            </button>
          }
          @if (permittedBusinesses.length > 0) {
            <button
              type="button"
              class="sm-switch is-dark"
              (click)="switchToBusiness()"
              [disabled]="isSwitchingToBusiness"
              [attr.aria-busy]="isSwitchingToBusiness">
              <span class="sm-switch-icon" aria-hidden="true"><ion-icon name="storefront"></ion-icon></span>
              <span>
                <span class="sm-switch-title">{{ isSwitchingToBusiness ? 'Switching...' : 'Switch to Business Portal' }}</span>
                <span class="sm-switch-note">{{ portalNote(permittedBusinesses, 'businesses') }}</span>
              </span>
              @if (isSwitchingToBusiness) {
                <ion-spinner name="crescent" aria-hidden="true"></ion-spinner>
              } @else {
                <ion-icon name="swap-horizontal" aria-hidden="true"></ion-icon>
              }
            </button>
          }
        }
      </section>
    }

    <section class="sm-section" aria-labelledby="sm-giving">
      <h3 class="sm-eyebrow" id="sm-giving">Your giving</h3>
      <ul class="sm-list">
        <li>
          <button type="button" class="sm-row" (click)="goToItem('recurring-donations')">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="repeat-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Recurring Donations</span>
              <span class="sm-row-note">Manage donation subscriptions</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        <li>
          <button type="button" class="sm-row" (click)="goToPage('user-orders')">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="bag-handle-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Orders</span>
              <span class="sm-row-note">See your marketplace orders</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        @if (hasEventTickets) {
          <li>
            <button type="button" class="sm-row" (click)="goToPage('event-tickets')">
              <span class="sm-row-icon" aria-hidden="true"><ion-icon name="ticket-outline"></ion-icon></span>
              <span class="sm-row-text">
                <span class="sm-row-title">Event Tickets</span>
                <span class="sm-row-note">View tickets and QR codes</span>
              </span>
              <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
            </button>
          </li>
        }
      </ul>
    </section>

    <section class="sm-section" aria-labelledby="sm-account">
      <h3 class="sm-eyebrow" id="sm-account">Account</h3>
      <ul class="sm-list">
        <li>
          <button type="button" class="sm-row" (click)="goToItem('user-info')">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="person-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Account Information</span>
              <span class="sm-row-note">Name, phone number, address</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        <li>
          <button type="button" class="sm-row" (click)="goToItem('settings')">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="settings-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Settings</span>
              <span class="sm-row-note">Preferences, privacy, security</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
      </ul>
    </section>

    <section class="sm-section" aria-labelledby="sm-orgs">
      <h3 class="sm-eyebrow" id="sm-orgs">Organizations</h3>
      <ul class="sm-list">
        <li>
          <button type="button" class="sm-row" (click)="goToItem('manage-charity')">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="heart-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Manage Charities</span>
              <span class="sm-row-note">Manage or claim a charity</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        <li>
          <button type="button" class="sm-row" (click)="goToItem('manage-business')">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="storefront-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Manage Businesses</span>
              <span class="sm-row-note">Manage a business account</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
      </ul>
    </section>

    @if (authorityLoaded && !hasPortals) {
      <div class="sm-switches">
        <button type="button" class="sm-switch" (click)="goToItem('manage-charity')">
          <span class="sm-switch-icon" aria-hidden="true"><ion-icon name="heart"></ion-icon></span>
          <span>
            <span class="sm-switch-title">Claim a Charity</span>
            <span class="sm-switch-note">Run your charity on Sunny Street</span>
          </span>
          <ion-icon name="chevron-forward" aria-hidden="true"></ion-icon>
        </button>
      </div>
    }

    <footer class="sm-footer">
      <ul class="sm-list">
        <li>
          <button type="button" class="sm-row is-quiet" (click)="goToPage('support')">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="help-circle-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Frequently Asked Questions</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        <li>
          <button type="button" class="sm-row is-danger" (click)="signOut()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="log-out-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Log Out</span>
            </span>
            <span aria-hidden="true"></span>
          </button>
        </li>
      </ul>

      @if (shouldShowVersion) {
        <div class="sm-version version-display">
          <span>{{ appVersion }}</span>
          <ion-button
            fill="clear"
            size="small"
            (click)="checkForUpdates()"
            [disabled]="pwaUpdateService.isChecking()"
            aria-label="Check for updates"
            title="Check for updates"
          >
            @if (pwaUpdateService.isChecking()) {
              <ion-spinner slot="icon-only" name="crescent"></ion-spinner>
            } @else {
              <ion-icon slot="icon-only" name="refresh-outline"></ion-icon>
            }
          </ion-button>
        </div>
      }
    </footer>
  </nav>
</ion-content>
